let listeners = [];

const state = {
  isRecording: false,
  records: [],
};
let snapshot = state;

const notify = () => {
  listeners.forEach((listener) => listener());
};

const updateSnapshot = () => {
  snapshot = {
    isRecording: state.isRecording,
    records: state.records,
  };
};

const sanitizeRecord = (record) => ({
  ...record,
  timestamp: record.timestamp || new Date().toISOString(),
});

export const subscribeHttpRecorder = (listener) => {
  listeners.push(listener);

  return () => {
    listeners = listeners.filter((item) => item !== listener);
  };
};

export const getHttpRecorderSnapshot = () => snapshot;

export const startHttpRecording = () => {
  state.isRecording = true;
  updateSnapshot();
  notify();
};

export const pauseHttpRecording = () => {
  state.isRecording = false;
  updateSnapshot();
  notify();
};

export const clearHttpRecorderRecords = () => {
  state.records = [];
  updateSnapshot();
  notify();
};

export const addHttpRecorderRecord = (record) => {
  if (!state.isRecording) {
    return;
  }

  state.records = [...state.records, sanitizeRecord(record)];
  updateSnapshot();
  notify();
};

export const exportHttpRecorderRecords = () => {
  const blob = new Blob([JSON.stringify(state.records, null, 2)], {
    type: "application/json",
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = `http-recorder-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
